import {
  CONCURRENCY_KEY,
  CREDIT_BLOCKS_KEY,
  INTERVAL_KEY,
  PLAN_INTERVAL,
  PROJECTS_KEY,
} from '../constants';

export class PlanConfiguration {
  concurrency: number | null;

  projects: number | null;

  interval: string;

  creditBlocks: number | null;

  constructor({
    concurrency = null,
    projects = null,
    creditBlocks = null,
    interval = PLAN_INTERVAL.YEAR,
  }: Partial<PlanConfiguration> = {}) {
    if (![concurrency, projects, creditBlocks].some((val) => Number.isFinite(val))) {
      throw new Error('Either concurrency / projects or credits blocks must be non-null.');
    }
    this[CONCURRENCY_KEY] = concurrency;
    this[INTERVAL_KEY] = interval;
    this[PROJECTS_KEY] = projects;
    this[CREDIT_BLOCKS_KEY] = creditBlocks;
  }
}
